<section class="p-6 relative">
  <div class="pt-8 overline-o1 mb-2">{{'locationModal.title' | translate}}</div>
  <div mat-dialog-close class="dialog-container__close dialog-container__close--l dialog-container__close--white cursor-pointer absolute" aria-label="Close dialog">
    <mat-icon svgIcon="close-circle" class="mr-2"></mat-icon>
  </div>

  <div class="mat-mdc-dialog-content overflow-y-auto visor-height">
    <google-map
      height="400px"
      width="100%"
      [center]="center"
      [zoom]="14">

      <map-marker
        [position]="marker.position"
        [label]="marker.label">
      </map-marker>
    </google-map>
  </div>

</section>
